import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function Help() {
  const { currentUser, logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  const applicationSteps = [
    {
      step: 1,
      title: 'Phone Number & Consents',
      description: 'Fill phone number and give all required consents on the page'
    },
    {
      step: 2,
      title: 'Phone OTP Validation',
      description: 'Verify your phone number with the OTP received via SMS'
    },
    {
      step: 3,
      title: 'Email ID',
      description: 'Provide your email address'
    },
    {
      step: 4,
      title: 'Email OTP Validation',
      description: 'Verify your email with the OTP received'
    },
    {
      step: 5,
      title: 'Basic Details',
      description: 'Fill basic details including Salutation, Name (as per PAN), Gender (Male, Female, Others), FATCA declaration, PEP declaration, and CIBIL check consent'
    },
    {
      step: 6,
      title: 'Other Details',
      description: 'Provide professional details: Profession, Income (applicable for salaried and self-employed), and Marital Status'
    },
    {
      step: 7,
      title: 'Aadhaar Details & OTP',
      description: 'Enter Aadhaar details and verify with OTP'
    },
    {
      step: 8,
      title: 'Address Details',
      description: 'Add communication address, or skip it (in which case communication address is same as permanent). Note: Card is delivered to communication address only'
    },
    {
      step: 9,
      title: 'Book Fixed Deposit',
      description: 'Book Fixed Deposit by adding amount and UPI ID (UPI ID should be same as yours)'
    },
    {
      step: 10,
      title: 'Complete Payment',
      description: 'Complete payment from your UPI app'
    },
    {
      step: 11,
      title: 'Nominee Details',
      description: 'Fill nominee details or skip this step'
    },
    {
      step: 12,
      title: 'Consent & VKYC',
      description: 'Provide consent to MITC, KFS and CMA, then start VKYC'
    },
    {
      step: 13,
      title: 'Complete VKYC',
      description: 'Complete Video KYC process, after which your customer ID will be generated'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-800">42Cards Solutions DSA Portal</h1>
          <div className="flex items-center">
            <span className="mr-4 text-gray-600">Welcome, {currentUser?.name}</span>
            <button
              onClick={handleLogout}
              className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition duration-200"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="flex items-center">
              <div className="flex space-x-4">
                <Link
                  to="/dashboard"
                  className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Dashboard
                </Link>
                <Link
                  to="/generate-lead"
                  className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Generate Lead
                </Link>
                <Link
                  to="/leads"
                  className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  My Leads
                </Link>
                <Link
                  to="/help"
                  className="text-white px-3 py-2 rounded-md text-sm font-medium bg-gray-900"
                >
                  Help
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main>
        <div className="max-w-4xl mx-auto py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <div className="bg-white shadow rounded-lg p-6">
              <h2 className="text-2xl font-semibold mb-2">CUB Credit Card Application Process</h2>
              <p className="text-gray-600 mb-6">Complete guide for customer application journey</p>
              
              <div className="space-y-4">
                {applicationSteps.map((item) => (
                  <div key={item.step} className="border border-gray-200 rounded-lg p-4 hover:border-blue-300 transition">
                    <div className="flex items-start">
                      <div className="flex-shrink-0">
                        <div className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold">
                          {item.step}
                        </div>
                      </div>
                      <div className="ml-4">
                        <h3 className="text-lg font-medium text-gray-900">{item.title}</h3>
                        <p className="text-gray-600 mt-1">{item.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-semibold text-blue-900 mb-2">Important Notes:</h3>
                <ul className="list-disc list-inside text-blue-800 space-y-1">
                  <li>Customer must complete all steps to successfully apply for the credit card</li>
                  <li>OTP verification is required for both phone and email</li>
                  <li>Aadhaar verification is mandatory</li>
                  <li>Video KYC (VKYC) is the final step before customer ID generation</li>
                  <li>Fixed Deposit booking is required to determine credit limit</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Help;